<template>
    <el-dialog top="5vh" width="1200px" :title="`绩效${isView ? '详情' : '调整'}`" :visible.sync="visible"
        class="legal-perform-adjust-dialog" :before-close="close">
        <div class="adjust-message">
            <span>业务类型：{{ businessTypeObj[businessType] }}</span>
            <span>供应商名称：{{ supplierNameCn }}</span>
            <span>考核月份：{{ month }}</span>
            <span>月度绩效得分：<span :class="+countScore < 90 ? 'red-score' : 'green-score'">{{ countScore }}</span></span>
            <span>月度绩效目标得分：≥90</span>
        </div>
        <el-table :data="tableData" style="width: 100%" v-loading="loading" border>
            <el-table-column prop="indicatorItems_" label="指标项" width="150"
                :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="assessmentObjectives_" label="指标考核目标" width="150"
                :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="weight_" label="权重" width="100"></el-table-column>
            <el-table-column prop="indicatorCompletion" label="指标完成" width="150">
                <template slot-scope="scope">
                    <span v-if="EXTRA_ITEMS.includes(scope.row.indicatorItems)">-</span>
                    <!-- <el-input v-if="scope.row.indicatorItems === STABILITY && !isView"
                        v-model.trim="scope.row.indicatorCompletion" placeholder="请输入数值"
                        @input="handleTargetInput($event, scope.$index)">
                        <template slot="append">%</template>
                    </el-input> -->
                    <span v-else>{{ scope.row.indicatorCompletion }}{{ ((scope.row.indicatorCompletion === 0 ||
                        scope.row.indicatorCompletion) && !['12', '13'].includes(scope.row.indicatorItems)) ?
                        '%' : '' }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="indicatorCompletionScore" label="指标得分" width="100">
                <template slot-scope="scope">
                    <el-input v-if="EXTRA_ITEMS.includes(scope.row.indicatorItems) && !isView"
                        v-model.trim="scope.row.indicatorCompletionScore"
                        :class="scope.row.indicatorItems === EXTRA_ITEMS[0] ? 'red-score' : 'green-score'"
                        @input="handleScoreInput($event, scope.$index)"></el-input>
                    <span v-else-if="TRANS_RANGE_ITEMS.includes(scope.row.indicatorItems)"
                        :class="+scope.row.indicatorCompletionScore < 0 ? 'red-score' : 'green-score'">{{
                            scope.row.indicatorCompletionScore }}</span>
                    <span v-else
                        :class="+scope.row.indicatorCompletionScore < +scope.row.weight ? 'red-score' : 'green-score'">{{
                            scope.row.indicatorCompletionScore }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="denominator" label="统计分母" width="150">
                <template slot-scope="scope">
                    <span v-if="EXTRA_ITEMS.includes(scope.row.indicatorItems)">-</span>
                    <template v-else>
                        <!-- 退货及时率 -->
                        <template v-if="scope.row.indicatorItems === '11' && scope.row.dataBankLink">
                            <a class="black-text" :href="scope.row.dataBankLink.split(';')[0]" target="_blank" v-if="scope.row.dataBankLink.split(';')[0]">{{ scope.row.denominator ? scope.row.denominator.split('+')[0] : ''
                            }}</a>+<a class="black-text" :href="scope.row.dataBankLink.split(';')[1]" target="_blank" v-if="scope.row.dataBankLink.split(';')[1]">{{ scope.row.denominator ? scope.row.denominator.split('+')[1] : ''
                            }}</a>
                        </template>
                        <a class="black-text" :href="scope.row.dataBankLink" target="_blank" v-if="scope.row.indicatorItems !== '11' && scope.row.dataBankLink">{{ scope.row.denominator
                        }}</a>
                        <span v-if="!scope.row.dataBankLink">{{ scope.row.denominator }}</span>
                    </template>
                </template>
            </el-table-column>
            <el-table-column prop="statisticsDenominator" label="统计分母值">
                <template slot-scope="scope">
                    <span v-if="EXTRA_ITEMS.includes(scope.row.indicatorItems)">-</span>
                    <template v-else>
                        <el-input v-if="!isView" v-model.trim="scope.row.statisticsDenominator" placeholder="请输入数值"
                            @input="calcTargetComplete($event, scope.$index)" />
                        <span v-else>{{ scope.row.statisticsDenominator }}</span>
                    </template>
                </template>
            </el-table-column>
            <el-table-column prop="numerator" label="统计分子" width="150">
                <template slot-scope="scope">
                    <span v-if="EXTRA_ITEMS.includes(scope.row.indicatorItems)">-</span>
                    <template v-else>

                        <!-- 退货及时率 -->
                        <template v-if="scope.row.indicatorItems === '11' && scope.row.dataBankLink">
                            <a class="black-text" :href="scope.row.dataBankLink.split(';')[0]" target="_blank" v-if="scope.row.dataBankLink.split(';')[0]">{{ scope.row.numerator ? scope.row.numerator.split('+')[0] : ''
                            }}</a>+<a class="black-text" :href="scope.row.dataBankLink.split(';')[1]" target="_blank" v-if="scope.row.dataBankLink.split(';')[1]">{{ scope.row.numerator ? scope.row.numerator.split('+')[1] : ''
                            }}</a>
                        </template>
                        <a class="black-text" :href="scope.row.dataBankLink" target="_blank" v-if="scope.row.indicatorItems !== '11' && scope.row.dataBankLink">{{ scope.row.numerator
                        }}</a>
                        <span v-if="!scope.row.dataBankLink">{{ scope.row.numerator }}</span>
                    </template>
                </template>
            </el-table-column>
            <el-table-column prop="statisticsNumerator" label="统计分子值">
                <template slot-scope="scope">
                    <span v-if="EXTRA_ITEMS.includes(scope.row.indicatorItems)">-</span>
                    <template v-else>
                        <el-input v-if="!isView" v-model.trim="scope.row.statisticsNumerator" placeholder="请输入数值"
                            @input="calcTargetComplete($event, scope.$index)" />
                        <span v-else>{{ scope.row.statisticsNumerator }}</span>
                    </template>
                </template>
            </el-table-column>
        </el-table>
        <div class="sub-title">操作记录</div>
        <OperateRecordList ref="orlRef" />
        <div slot="footer" class="dialog-footer" v-if="!isView">
            <el-button type="primary" :loading="submitLoading" @click="handleSubmit">保存提交</el-button>
            <el-button @click="close">取 消</el-button>
        </div>
    </el-dialog>
</template>
<script>
import Decimal from 'decimal.js'
import { dictWithUrl } from '@/components/lots/api'
import { selectSupplierPerformanceConfigurationAdjustDetail, getScoreByValue, submitAdjust, selectLegalPersonPerformanceConfiguration } from '../../../../api/performManage.js'
import { TRANSPORTATION_NUM, DELIVERY_NUM } from '../../../../constant/constant.js'
import OperateRecordList from '../../components/OperateRecordList.vue'
import { ACTION_TYPE } from '../../constant.js'

// SUPPLIER_INDICATOR_ITEMS_TYPE
const TRANS_RANGE_ITEMS = ['5', '6'] // 5'运力线上化率', 6'运力稳定率'
const STABILITY = '6' // 运力稳定率
const DEDUCT_ITEM = '7' // 减分项（客户投诉）
const BONUS_ITEM = '8' // 加分项（客户表扬）
const EXTRA_ITEMS = [DEDUCT_ITEM, BONUS_ITEM]
const EXTRA_STABILITY = [DEDUCT_ITEM, BONUS_ITEM, STABILITY]

export default {
    components: { OperateRecordList },
    props: {
        // height: {
        //     type: String | Number,
        //     default() {
        //         return '300px';
        //     }
        // }
        // visible: {
        //     type: Boolean,
        //     default() {
        //         return false
        //     },
        // },
    },
    data() {
        return {
            EXTRA_STABILITY,
            STABILITY,
            visible: false,
            loading: false,
            submitLoading: false,
            id: null,
            configurationCode: null,
            businessType: '',
            supplierNameCn: '',
            month: '',
            countScore: '',
            dictData: {
                SUPPLIER_INDICATOR_ITEMS_TYPE: {},
                PERFORM_NUMERATOR: {},
                PERFORM_DENOMINATOR: {},
            },
            tableData: [],
            businessTypeObj: {
                [TRANSPORTATION_NUM]: '运输',
                [DELIVERY_NUM]: '配送',
                '5': '配送(新)',
            },
            EXTRA_ITEMS,
            TRANS_RANGE_ITEMS,
            deliveryTimeout: null,
            isView: false,
            deliveryNewCalc: [], //配送新得分计算配置
        }
    },
    methods: {
        async open(data, isView) {
            this.visible = true
            await dictWithUrl('SUPPLIER_INDICATOR_ITEMS_TYPE,PERFORM_DENOMINATOR,PERFORM_NUMERATOR').then(res => {
                if (res && +res.code === 0) {
                    this.dictData = res.data
                }
            }).catch(err => { })
            this.id = data.id
            this.isView = isView
            await this.loadData()
            if(this.businessType === '5'){
                //配送新需要查询得分配置
                this.getCalc()
            }
            this.$nextTick(() => {
                this.$refs.orlRef.init(data)
            })
        },
        getCalc(){
            this.loading = true
            selectLegalPersonPerformanceConfiguration({businessType: this.businessType}).then(res => {
                if (res && +res.code === 0) {
                    this.deliveryNewCalc = res.data || []
                }
            }).finally(() => {
                this.loading = false
            })
        },
        loadData() {
            this.loading = true
            const params = { id: this.id, operativeFunction: ACTION_TYPE.CHANGE }
            if(this.isView){
                params.checkFlag = '1'
            }
            return selectSupplierPerformanceConfigurationAdjustDetail(params)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.configurationCode = res.data.configurationCode
                        this.businessType = res.data.businessType
                        this.supplierNameCn = res.data.supplierNameCn
                        this.month = res.data.month
                        this.countScore = res.data.countScore
                        this.tableData = (res.data.detailList || []).map(item => {
                            item.indicatorItems_ = this.dictData.SUPPLIER_INDICATOR_ITEMS_TYPE[item.indicatorItems]
                            item.denominator = this.dictData.PERFORM_DENOMINATOR[item.indicatorItems]
                            item.numerator = this.dictData.PERFORM_NUMERATOR[item.indicatorItems]
                            if (EXTRA_ITEMS.includes(item.indicatorItems)) {
                                item.assessmentObjectives_ = '-'
                                item.weight_ = '-'
                            } else {
                                item.assessmentObjectives_ = item.assessmentObjectives + (!['12', '13'].includes(item.indicatorItems)?'%':'')
                                item.weight_ = item.weight
                            }
                            // indicatorCompletion_ 指标完成原始值，indicatorCompletionScore_ 指标得分原始值，用于作对比
                            item.indicatorCompletion_ = item.indicatorCompletion
                            item.indicatorCompletionScore_ = item.indicatorCompletionScore
                            item.statisticsDenominator_ = item.statisticsDenominator
                            item.statisticsNumerator_ = item.statisticsNumerator
                            return item
                        })
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },
        close() {
            this.tableData = []
            this.deliveryNewCalc = []
            this.$refs.orlRef.reset()
            this.visible = false
        },
        calcTargetComplete(val, index) {
            clearTimeout(this.deliveryTimeout)
            if (this.validDenominator(this.tableData[index].statisticsDenominator,this.tableData[index].indicatorItems) && this.validNumerator(this.tableData[index].statisticsNumerator,this.tableData[index].indicatorItems) && +this.tableData[index].statisticsNumerator <= +this.tableData[index].statisticsDenominator) {
                this.tableData[index].indicatorCompletion = (this.tableData[index].statisticsNumerator / this.tableData[index].statisticsDenominator * (['12', '13'].includes(this.tableData[index].indicatorItems) ? 1000000 : 100)).toFixed(['12', '13'].includes(this.tableData[index].indicatorItems) ? 8 : 2)
                if (this.businessType === TRANSPORTATION_NUM) {
                    this.calculateScoreOfTransport(this.tableData[index].indicatorCompletion, index)
                } else if (this.businessType === DELIVERY_NUM) {
                    this.calculateScoreOfDelivery(this.tableData[index].indicatorCompletion, index)
                }else if (this.businessType === '5') {
                    //业务类型=配送（新）
                    this.calculateScoreOfDeliveryNew(this.tableData[index].indicatorCompletion, index)
                }
            } else {
                this.tableData[index].indicatorCompletion = null
                this.tableData[index].indicatorCompletionScore = null
            }
        },
        //校验分母
        validDenominator(val, indicatorItems) {
            if(['12', '13'].includes(indicatorItems)){
                //破损率，遗失率 输入限制 1-9999999999.99999999
                const reg = /^([1-9]{1}\d{0,9})$|^[0-9]{1}\d{0,11}[\.]{1}[0-9]{1,8}$/
                return reg.test(val)
            }else if(['9','10', '11'].includes(indicatorItems)){
                //配送及时率,回单上传及时率,退货及时率	输入限制 1-9999999999
                const reg = /^([1-9]{1}\d{0,9})$/
                return reg.test(val)
            }
            else{
                //1-99999999
                const reg = /^[1-9]{1}\d{0,7}$/
                return reg.test(val)
            }
        },
        //校验分子
        validNumerator(val, indicatorItems) {
            if(['12', '13'].includes(indicatorItems)){
                //破损率，遗失率 输入限制 0-9999999999.99999999
                const reg = /^(0|[1-9]{1}\d{0,9})$|^[0-9]{1}\d{0,11}[\.]{1}[0-9]{1,8}$/
                return reg.test(val)
            }else if(['9','10', '11'].includes(indicatorItems)){
                //配送及时率,回单上传及时率,退货及时率	输入限制 0-9999999999
                const reg = /^(0|[1-9]{1}\d{0,9})$/
                return reg.test(val)
            }
            else{
                //0-99999999
                const reg = /^[0-9]{1}\d{0,7}$/
                return reg.test(val)
            }
        },
        handleTargetInput(val, index) {
            if (val === '' || isNaN(Number(val)) || Number(val) > 100 || Number(val) < 0) {
                this.tableData[index].indicatorCompletionScore = null
                this.setSum()
            } else if (this.businessType === TRANSPORTATION_NUM) {
                this.calculateScoreOfTransport(val, index)
            } else if (this.businessType === DELIVERY_NUM) {
                this.calculateScoreOfDelivery(val, index)
            }
        },
        calculateScoreOfTransport(val, index) {
            clearTimeout(this.deliveryTimeout)
            this.deliveryTimeout = setTimeout(() => {
                const params = {
                    configurationCode: this.configurationCode,
                    indicatorItems: this.tableData[index].indicatorItems,
                    value: val,
                }
                getScoreByValue(params).then(res => {
                    if (res && +res.code === 0) {
                        this.tableData[index].indicatorCompletionScore = res.data
                        this.setSum()
                    }
                })
            }, 300)
        },
        calculateScoreOfDelivery(val, index) {
            let { indicatorItems, assessmentObjectives, weight } = this.tableData[index]
            weight = weight * 1
            if (TRANS_RANGE_ITEMS.includes(indicatorItems)) {
                this.tableData[index].indicatorCompletionScore = Number(val) >= Number(assessmentObjectives) ? 0 : weight
            } else {
                //指标得分大于权重，则取权重
                const score = Decimal(val).div(assessmentObjectives).mul(weight).toNumber()
                this.tableData[index].indicatorCompletionScore = score > weight ? weight.toFixed(2) : score.toFixed(2)
            }
            this.setSum()
        },
        calculateScoreOfDeliveryNew(val, index) {
            let { indicatorItems, assessmentObjectives, weight } = this.tableData[index]
            weight = weight * 1
            const calcItem = this.deliveryNewCalc.find(v => v.indicatorItems === indicatorItems)
            const calc = (calcItem && calcItem.intervalList && calcItem.intervalList[0]) ? calcItem.intervalList[0] : {}
            if (TRANS_RANGE_ITEMS.includes(indicatorItems)) {
                this.tableData[index].indicatorCompletionScore = Number(val) >= Number(assessmentObjectives) ? 0 : weight
            } else if(['9','10','11'].includes(indicatorItems)){
                //配送及时率，回单上传及时率，退货及时率
                //计算公式：比指标考核目标每低1%，扣2分，   不足1%，按1%计算，扣分不封顶，扣至0分为止
                const decreaseRatio = calc.compareScores //递减率
                const deduceScore = calc.deductScores //扣分
                if(Number(assessmentObjectives) > Number(val)){
                    //考核目标比指标完成大，需要扣分
                    const totalDeduceScore = Math.ceil((Number(assessmentObjectives) - Number(val)) / decreaseRatio) * deduceScore //总扣分
                    const isLimit = calc.deductTopType === '2' //是否封顶
                    const limitScore = calc.maximumScore  //封顶扣分
                    const score = weight - (isLimit ? (totalDeduceScore > limitScore ? limitScore : totalDeduceScore) : totalDeduceScore) //得分
                    this.tableData[index].indicatorCompletionScore = score > 0 ? score.toFixed(2) : 0
                }else{
                    //指标完成大于等于考核目标，拿满分
                    this.tableData[index].indicatorCompletionScore = weight
                }
            } else {
                /**
                 * 1、破损完成率=考核目标/破损率，扣分系数=（1-破损完成率）/2%。
                    2、当扣分系数＞0，破损完成率每比100%低2%，扣1分，不足2%，按2%计算，扣分 封顶 10分；
                    扣分=[扣分系数]；指标得分=权重-扣分；
                    注：[扣分系数]代表向上取整函数，定义为大于等于扣分系数的最小整数，例如[3.6]=4；
                    3、当扣分系数≤0，指标得分为满分
                 */
                if(Number(val) === 0){
                    //破损率，遗失率为0，拿满分
                    this.tableData[index].indicatorCompletionScore = weight
                }else{
                    //破损率，遗失率不为0
                    const decreaseRatio = calc.compareScores //递减率
                    const deductionCoefficient = Math.ceil((1 - Number(assessmentObjectives) / Number(val)) / (decreaseRatio / 100)) //扣分系数
                    if(deductionCoefficient <= 0){
                        //拿满分
                        this.tableData[index].indicatorCompletionScore = weight
                    }else{
                        const deduceScore = calc.deductScores //扣分
                        const totalDeduceScore = Math.ceil((100 - Number(assessmentObjectives) / Number(val)*100) / decreaseRatio) * deduceScore //总扣分
                        const isLimit = calc.deductTopType === '2' //是否封顶
                        const limitScore = calc.maximumScore  //封顶扣分
                        const score = weight - (isLimit ? (totalDeduceScore > limitScore ? limitScore : totalDeduceScore) : totalDeduceScore) //得分
                        this.tableData[index].indicatorCompletionScore = score > 0 ? score.toFixed(2) : 0
                    }
                }
            }
            this.setSum()
        },
        setSum() {
            let sum = Decimal(0)
            this.tableData.forEach(item => {
                if (!isNaN(Number(item.indicatorCompletionScore))) {
                    sum = sum.add(Number(item.indicatorCompletionScore))
                }
            })
            this.countScore = sum.toNumber()
        },
        handleScoreInput(val, index) {
            this.setSum()
        },
        handleSubmit() {
            if (this.validate()) {
                this.submitLoading = true
                submitAdjust(this.getParams()).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('保存提交成功!')
                        this.$emit('success')
                        this.close()
                    }
                }).finally(() => { this.submitLoading = false })
            }
        },
        getParams() {
            const params = {
                businessType: this.businessType,
                configurationCode: this.configurationCode,
                countScore: this.countScore,
                id: this.id,
                // id: 2,
                month: this.month,
                supplierNameCn: this.supplierNameCn,
                detailList: JSON.parse(JSON.stringify(this.tableData)),
            }
            params.detailList.forEach(item => {
                item.indicatorCompletion = ['', null].includes(item.indicatorCompletion) ? item.indicatorCompletion : Number(item.indicatorCompletion)
                // 更改标识 0-未更改 1-更改
                if (EXTRA_ITEMS.includes(item.indicatorItems)) {
                    item.updateFlag = Number(item.indicatorCompletionScore) === Number(item.indicatorCompletionScore_) ? '0' : '1'
                } 
                // else if (STABILITY.includes(item.indicatorItems)) {
                //     //运力稳定指标由于可以空值保存，所以要区分校验
                //     if (['', null].includes(item.indicatorCompletion_)) {
                //         item.updateFlag = ['', null].includes(item.indicatorCompletion) ? '0' : '1'
                //     } else {
                //         if(['', null].includes(item.indicatorCompletion)){
                //             item.updateFlag = '1' 
                //         }else{
                //             item.updateFlag = Number(item.indicatorCompletion) === Number(item.indicatorCompletion_) ? '0' : '1'
                //         }
                //     }
                // }
                else {
                    //统计分子值与统计分母值都未变更则为0，否则为1
                    item.updateFlag = Number(item.statisticsDenominator) === Number(item.statisticsDenominator_) && Number(item.statisticsNumerator) === Number(item.statisticsNumerator_) ? '0' : '1'
                }
                delete item.indicatorItems_
                delete item.assessmentObjectives_
                delete item.weight_
                delete item.indicatorCompletion_
                delete item.indicatorCompletionScore_
                delete item.statisticsNumerator_
                delete item.statisticsDenominator_

            })
            return params
        },
        // 数据格式校验
        validate() {
            //由于大数据那边来不及开发，【运力稳定率】的指标完成默认为空，并且允许空值保存 
            // let numberFlag = this.tableData.some(item => (!EXTRA_ITEMS.includes(item.indicatorItems) && !STABILITY.includes(item.indicatorItems) && !/^(?:0(\.\d{1,2})?|[1-9][0-9]?(\.\d{1,2})?|100)$/.test(item.indicatorCompletion)) || (STABILITY.includes(item.indicatorItems) && item.indicatorCompletion && !/^(?:0(\.\d{1,2})?|[1-9][0-9]?(\.\d{1,2})?|100)$/.test(item.indicatorCompletion)))

            //1017改版后只有【运力稳定率】可以输入指标完成
            // let numberFlag = this.tableData.some(item => STABILITY.includes(item.indicatorItems) && item.indicatorCompletion && !/^(?:0(\.\d{1,2})?|[1-9][0-9]?(\.\d{1,2})?|100)$/.test(item.indicatorCompletion))
            // if (numberFlag) {
            //     this.$message.warning('指标完成只能输入0-100的数字，可保留2位小数')
            //     return false
            // }
            const deductItem = this.tableData.find(item => DEDUCT_ITEM === item.indicatorItems)
            if (deductItem && !!deductItem.indicatorCompletionScore && !/^-\d+(\.\d{1,2})?$/.test(deductItem.indicatorCompletionScore)) {
                this.$message.warning('减分项（客户投诉）只能输入负值，可保留2位小数')
                return false
            }
            const bonusItem = this.tableData.find(item => BONUS_ITEM === item.indicatorItems)
            if (bonusItem && !!bonusItem.indicatorCompletionScore && !/^\+?\d+(\.\d{1,2})?$/.test(bonusItem.indicatorCompletionScore)) {
                this.$message.warning('加分项（客户表扬）只能输入正值，可保留2位小数')
                return false
            }
            //业务类型=配送时，[发运及时率,到货及时率,回单及时率,货物完好率] 这4个指标得分不可大于权重
            if (this.businessType === DELIVERY_NUM && this.tableData.some(v => !EXTRA_ITEMS.includes(v.indicatorItems) && !TRANS_RANGE_ITEMS.includes(v.indicatorItems) && +v.indicatorCompletionScore > +v.weight)) {
                this.$message.warning('指标得分不可大于权重')
                return false
            }
            const validDenOrNum = this.tableData.every(v => (this.validNumerator(v.statisticsNumerator, v.indicatorItems) && this.validDenominator(v.statisticsDenominator, v.indicatorItems) && (+v.statisticsNumerator <= +v.statisticsDenominator)) || EXTRA_ITEMS.includes(v.indicatorItems))
            if (!validDenOrNum) {
                this.$message.warning(`统计分母值应为非0且最多${this.businessType==='5'?'10':'8'}位正整数${this.businessType==='5'?'(破损率/遗失率8位小数)':''}，统计分子值应为0或最多${this.businessType==='5'?'10':'8'}位正整数${this.businessType==='5'?'(破损率/遗失率8位小数)':''}并且不能大于统计分母值`)
                return false
            }

            return true
        },
    },
    mounted() {
        // dictWithUrl('SRM_ASSESSMENT_BUSYNESS_TYPE').then(res => {
        //     if (res && +res.code === 0) {
        //         this.dictData = res.data
        //     }
        // });
    },
    // watch: {
    //     visible(v) {
    //         if (v) {
    //             // this.$refs.orlRef.loadData()
    //         }
    //     },
    // },
}
</script>
<style lang="less">
.legal-perform-adjust-dialog {
    .adjust-message {
        margin-bottom: 10px;

        &>span {
            display: inline-block;
            margin-right: 20px;
        }
    }

    .red-score {
        color: red;

        .el-input__inner {
            color: red;
        }
    }

    .green-score {
        color: green;

        .el-input__inner {
            color: green;
        }
    }

    .sub-title {
        margin: 20px 0 10px;
        font-size: 16px;
    }

    .black-text {
        text-decoration: underline;
        color: rgb(102, 102, 102);
    }
}
</style>
